export type NewsItem = {
  id: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  topicId: string;
  publishedAt: string;
  image: string;
  tags: string[];
  author: string;
  views: number;
  heat: number;
  content: string[];
};

export type TopicItem = {
  id: string;
  name: string;
  subtitle: string;
  description: string;
  cover: string;
  keywords: string[];
};

export const newsList: NewsItem[] = [
  {
    id: "s1",
    title: "城中村改造补偿方案流出 居民连夜排队登记",
    summary:
      "一份标注为“第三轮征求意见稿”的补偿方案在社区群里流传，选择产权调换的比例明显高于货币补偿，街道办已回应。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-1",
    publishedAt: "2026-10-17T10:26:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=A%20busy%20registration%20desk%20outside%20an%20old%20residential%20community%20office%2C%20residents%20queuing%20with%20folders%20and%20documents%2C%20soft%20morning%20light%2C%20muted%20warm%20orange%20tones%2C%20editorial%20documentary%20photography%2C%20clean%20composition%2C%20high%20detail&width=1024&height=640&seq=baoliao-s1&orientation=landscape",
    tags: ["城市更新", "补偿方案"],
    author: "爆料网社会组",
    views: 184320,
    heat: 98,
    content: [
      "10月16日深夜，一张“第三轮征求意见稿”的截图在多个社区群内被反复转发。截图显示，本次补偿方案中产权调换的房源位置由原来的三公里外调整为就近两处安置地块，货币补偿单价则基本维持上一轮标准。",
      "17日清晨六点，社区服务中心门口已经排起长队。一位姓陈的居民告诉记者，大家最关心的是“先签约有没有额外奖励”以及过渡期租房补贴按什么标准发放，“文件里写得很模糊，我们只能来问”。",
      "街道办工作人员在现场回应称，网传文件确为征求意见稿，尚未最终定稿，本周内会组织三场居民说明会，逐条解释计算方式。工作人员同时提醒居民不要通过非官方渠道提交个人信息。",
    ],
  },
  {
    id: "e1",
    title: "林知夏工作室发声明 否认与经纪公司“阴阳合同”",
    summary:
      "针对网传两份金额相差近三倍的片酬合同，工作室凌晨发布声明称文件系伪造，并已委托律师取证。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-2",
    publishedAt: "2026-10-17T09:48:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20sealed%20legal%20document%20folder%20and%20a%20smartphone%20showing%20a%20statement%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20warm%20amber%20tones%2C%20editorial%20still%20life%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1024&height=640&seq=baoliao-e1&orientation=landscape",
    tags: ["经纪合约", "声明"],
    author: "爆料网娱乐组",
    views: 462810,
    heat: 96,
    content: [
      "17日凌晨两点，林知夏工作室在官方账号发布四百余字声明，称网传的两份“片酬合同”均系伪造，文件中的公章样式与公司现行用章不符，已委托律师对首发账号进行取证。",
      "事件的起点是16日晚间一个娱乐博主放出的九宫格图片，图中两份合同的项目名称相同，但金额一栏相差近三倍。该博主称素材来自“剧组内部人员”，但未提供更多可核实信息。",
      "截至发稿，涉事剧组与播出平台均未回应。多位从业者在采访中提到，近几年剧组合同普遍采用平台统一模板，出现“双合同”的概率不高，但演员与经纪公司的分成条款确实存在多种约定方式。",
    ],
  },
  {
    id: "s2",
    title: "三号线早高峰突发停运 官方通报：信号设备故障",
    summary:
      "早高峰时段三号线两站区间停运四十分钟，站外接驳巴士临时开行，多名乘客反映站内广播信息滞后。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-3",
    publishedAt: "2026-10-17T08:55:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Crowded%20modern%20subway%20platform%20with%20commuters%20waiting%20behind%20a%20closed%20glass%20barrier%2C%20cool%20grey%20architecture%20with%20warm%20signage%20lights%2C%20early%20morning%20atmosphere%2C%20documentary%20photojournalism%2C%20clean%20wide%20composition&width=1024&height=640&seq=baoliao-s2&orientation=landscape",
    tags: ["公共交通", "突发"],
    author: "爆料网社会组",
    views: 221940,
    heat: 92,
    content: [
      "17日7时50分左右，三号线东段两站区间列车陆续停运。站内显示屏打出“设备故障，请改乘其他线路”的提示，站台很快聚集了大量赶早班的乘客。",
      "8时32分，运营方发布通报称，故障原因为区间信号设备通信中断，已启动应急预案并加开两列空车疏运，同时对受影响的乘客提供延误证明。",
      "记者在现场看到，接驳巴士在三个出入口临时停靠，但排队队伍一度延伸到人行道。多位乘客表示，站内广播在最初十分钟内没有任何提示，“大家只能靠手机群消息互相通知”。",
    ],
  },
  {
    id: "e2",
    title: "周牧野新剧收视破2 剧组深夜加拍结局",
    summary:
      "开播九天收视率连续上扬，平台临时追加两集内容，知情人称补拍主要围绕男二号的支线结局。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-4",
    publishedAt: "2026-10-17T08:12:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Film%20set%20at%20night%20with%20warm%20practical%20lights%2C%20camera%20crane%20and%20crew%20silhouettes%2C%20rain%20on%20the%20street%2C%20cinematic%20moody%20orange%20and%20teal%20highlights%2C%20editorial%20behind-the-scenes%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-e2&orientation=landscape",
    tags: ["剧集", "收视"],
    author: "爆料网娱乐组",
    views: 318440,
    heat: 94,
    content: [
      "据排播平台数据，周牧野主演的都市悬疑剧开播九天收视率从1.42%一路上涨至2.03%，成为本季度首部破2的剧集。",
      "剧组工作人员向记者透露，原本已经杀青的剧组在16日晚重新集合，在原拍摄地补拍两场戏，“主要是男二号的支线结局，观众反馈太强烈，编剧改了收尾方式”。",
      "片方对此回应称，补拍属于正常的后期调整，不会影响既定排播，最后两集仍按原档期上线。",
    ],
  },
  {
    id: "s3",
    title: "网红奶茶店后厨被拍 冷藏柜温度记录异常",
    summary:
      "一段两分十七秒的后厨视频显示，部分原料未标注开封时间，冷藏柜温度记录连续三天为同一数字。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-5",
    publishedAt: "2026-10-16T22:40:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Commercial%20milk%20tea%20shop%20kitchen%20counter%20with%20stainless%20steel%20containers%2C%20sealed%20cups%20and%20a%20temperature%20log%20sheet%2C%20bright%20overhead%20lighting%2C%20clean%20realistic%20food%20safety%20inspection%20scene%2C%20warm%20neutral%20palette%2C%20high%20detail&width=1024&height=640&seq=baoliao-s3&orientation=landscape",
    tags: ["食品安全", "暗访"],
    author: "爆料网调查组",
    views: 276110,
    heat: 90,
    content: [
      "视频拍摄于10月14日下午，地点是城西一家排队常年超过三十人的网红奶茶门店。画面中，操作台旁的三种果酱均未标注开封日期，其中一盒已经出现明显分层。",
      "更受关注的是墙上的冷藏柜温度记录表。表格显示10月10日至12日的记录完全一致，均为“3.5℃”，连字迹倾斜的角度都相同。拍摄者称，这张表在三天内没有被任何人填写过。",
      "门店负责人在电话中回应称，记录表为“周汇总填写”，并非每日誊抄，同时承认部分原料标签管理不到位，已主动下架相关产品并配合市场监管部门检查。",
    ],
  },
  {
    id: "e3",
    title: "沈星野婚礼彩排照外泄 伴郎团阵容曝光",
    summary:
      "一组彩排现场照片在凌晨流出，婚礼地点被指为城郊一处私人庄园，宾客名单控制在八十人以内。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-6",
    publishedAt: "2026-10-16T21:05:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20outdoor%20wedding%20rehearsal%20venue%20at%20dusk%2C%20long%20table%20with%20white%20flowers%20and%20warm%20string%20lights%2C%20garden%20trees%20in%20soft%20focus%2C%20romantic%20golden%20hour%20tones%2C%20editorial%20event%20photography%2C%20clean%20composition&width=1024&height=640&seq=baoliao-e3&orientation=landscape",
    tags: ["婚礼", "现场"],
    author: "爆料网娱乐组",
    views: 398620,
    heat: 93,
    content: [
      "16日晚，一组疑似婚礼彩排的现场照在小范围流传。照片中，草坪上摆放着一条超过二十米的长桌，桌花以白色和浅杏色为主，没有明显的品牌标识。",
      "多位到场人员在社交平台发布了同一角度的照片，随后陆续删除。有知情者称，彩排主要确认走位和音响，正式仪式将安排在三天后，宾客规模控制在八十人以内。",
      "截至发稿，沈星野方面未对婚礼细节作出回应，其工作室仅表示“私人行程不便透露”。",
    ],
  },
  {
    id: "s4",
    title: "学区房中介费一夜上调 家长集体要求公开明细",
    summary:
      "多家中介将服务费从1.5%调至2.2%，并新增“信息咨询费”，部分家长已向市场监管部门投诉。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-1",
    publishedAt: "2026-10-16T19:20:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Real%20estate%20agency%20window%20with%20property%20listings%20and%20price%20cards%2C%20parents%20discussing%20outside%20on%20a%20sunny%20afternoon%2C%20warm%20urban%20street%20tones%2C%20documentary%20style%20photography%2C%20clean%20balanced%20composition%2C%20high%20detail&width=1024&height=640&seq=baoliao-s4&orientation=landscape",
    tags: ["房产中介", "学区"],
    author: "爆料网社会组",
    views: 132760,
    heat: 84,
    content: [
      "多位家长向记者提供的聊天记录显示，10月15日晚间起，片区内的三家中介先后通知客户，二手房买卖服务费由成交价的1.5%调整为2.2%，另收2000元“信息咨询费”。",
      "一位正在办理过户的家长算了一笔账：总价420万元的房源，调整后多支出近三万元。“合同都签了，突然说按新标准收，我们只能先停下来。”",
      "市场监管部门工作人员表示，已收到相关投诉并介入核查，重点确认中介是否在签约后单方面变更收费、是否明码标价。房管局同步提醒，购房者应在合同中明确服务费比例与支付节点。",
    ],
  },
  {
    id: "e4",
    title: "女团成员解约风波升级 前队友发文力挺",
    summary:
      "成员单方面宣布解约后，公司称合约仍有效，两位前队友先后发文，话题阅读量一夜破三亿。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-2",
    publishedAt: "2026-10-16T17:36:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20rehearsal%20room%20with%20mirrors%2C%20dance%20floor%20and%20a%20single%20spotlight%2C%20dramatic%20mood%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20editorial%20music%20industry%20photography%2C%20minimal%20composition%2C%20high%20detail&width=1024&height=640&seq=baoliao-e4&orientation=landscape",
    tags: ["偶像团体", "解约"],
    author: "爆料网娱乐组",
    views: 512300,
    heat: 97,
    content: [
      "16日下午，女团成员程一诺通过个人账号发布长文，称因“长期超负荷行程与分成争议”单方面解除合约，并表示愿意承担相应违约责任。",
      "所属公司两小时后回应，强调合约有效期至2028年，解约行为不具备法律效力，同时否认存在“行程超标”的情况，称所有安排均经成员本人确认。",
      "晚间，两位已离队的前队友先后发文。一人写道“有些事终于有人说了”，另一人则呼吁粉丝不要攻击仍在团内的成员。相关话题在四小时内冲上热搜首位。",
    ],
  },
  {
    id: "s5",
    title: "外卖骑手深夜救人视频刷屏 平台回应奖励",
    summary:
      "骑手在暴雨中背出被困车主，事后默默继续送单，平台称已授予“先锋骑手”称号并发放奖励。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-3",
    publishedAt: "2026-10-16T15:12:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%2C%20a%20delivery%20scooter%20parked%20beside%20a%20flooded%20underpass%2C%20distant%20streetlights%20creating%20warm%20orange%20glow%2C%20cinematic%20documentary%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-s5&orientation=landscape",
    tags: ["正能量", "骑手"],
    author: "爆料网社会组",
    views: 640520,
    heat: 95,
    content: [
      "视频拍摄于14日22时左右。画面中，一辆小轿车在积水的下穿通道内熄火，车主被困车内。一名身穿黄色工装的外卖骑手蹚水过去，把车主背到路边，全程不到两分钟。",
      "拍下视频的路人告诉记者，骑手把车钥匙交还后只说了句“我还有单要送”，就骑车离开了，“我们连他叫什么都没来得及问”。",
      "16日，平台确认该骑手为城东站点的高师傅，已授予“先锋骑手”称号并发放奖励，同时表示将为其申请当地见义勇为表彰。",
    ],
  },
  {
    id: "e5",
    title: "暑期档票房破45亿 三部大片同日提档",
    summary:
      "档期竞争提前进入白热化，两部动画与一部现实题材影片同时宣布提档，影院排片一夜重排。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-4",
    publishedAt: "2026-10-16T13:28:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20cinema%20lobby%20with%20illuminated%20movie%20poster%20lightboxes%20and%20a%20ticket%20counter%2C%20warm%20amber%20accent%20lighting%2C%20red%20velvet%20seats%20in%20the%20background%2C%20editorial%20photography%2C%20clean%20wide%20angle%2C%20high%20detail&width=1024&height=640&seq=baoliao-e5&orientation=landscape",
    tags: ["电影", "档期"],
    author: "爆料网娱乐组",
    views: 208740,
    heat: 88,
    content: [
      "截至16日中午，本档期总票房已突破45亿元，较去年同期增长约18%。其中现实题材影片《归途之外》以11.2亿元暂列首位。",
      "16日下午，三部原定下周上映的影片同时宣布提档至本周末，其中两部为动画电影。一位院线经理表示，排片表在半小时内被重排了两次，“这种情况一年也就遇到一两回”。",
      "业内人士分析，提档的核心原因是争夺周末的黄金场次，“谁先拿到20%以上的排片，谁就有机会在口碑发酵前站稳”。",
    ],
  },
  {
    id: "s6",
    title: "某连锁火锅店回收锅底 现场取证画面曝光",
    summary:
      "记者蹲守三天拍到后厨将剩余锅底过滤后回炉，门店负责人称“是员工个人行为”。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-5",
    publishedAt: "2026-10-16T11:02:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Hotpot%20restaurant%20kitchen%20with%20large%20steaming%20pots%20and%20stainless%20steel%20worktable%2C%20dim%20warm%20lighting%20with%20visible%20steam%2C%20industrial%20food%20preparation%20scene%2C%20documentary%20investigative%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-s6&orientation=landscape",
    tags: ["餐饮", "调查"],
    author: "爆料网调查组",
    views: 356920,
    heat: 91,
    content: [
      "10月10日至12日，记者在城北一家连锁火锅门店外蹲守，通过后门空隙拍到后厨操作画面。视频显示，服务员将顾客用餐后的锅底端回后厨，经过滤网倒入大桶，再与新油混合加热。",
      "按照相关规定，餐饮服务提供者不得使用回收的食品原料再加工。记者在现场还看到，盛放过滤后油料的大桶没有任何标识，紧挨着垃圾桶摆放。",
      "门店负责人在接受采访时先称“不可能”，在看到视频后改口称是“个别员工为节省成本私自操作”。品牌总部16日下午发布声明，宣布该门店停业整顿，并启动全国门店排查。",
    ],
  },
  {
    id: "e6",
    title: "苏念白被曝隐婚三年 本人回应只谈作品",
    summary:
      "有网友晒出疑似婚姻登记材料的局部截图，工作室未正面否认，仅强调“请关注新片”。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-6",
    publishedAt: "2026-10-16T09:44:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20portrait%20scene%20with%20a%20folded%20newspaper%20and%20a%20pair%20of%20sunglasses%20on%20a%20marble%20table%2C%20soft%20window%20light%2C%20muted%20beige%20and%20warm%20grey%20palette%2C%20editorial%20still%20life%2C%20elegant%20negative%20space%2C%20high%20detail&width=1024&height=640&seq=baoliao-e6&orientation=landscape",
    tags: ["明星动态", "回应"],
    author: "爆料网娱乐组",
    views: 287650,
    heat: 89,
    content: [
      "15日深夜，一位娱乐博主发布了一张疑似婚姻登记材料的局部截图，登记日期显示为三年前。截图中个人信息部分被大面积遮挡，仅保留日期与两处签名笔迹。",
      "16日上午，苏念白在品牌活动后接受简短采访，被问及此事时回应：“今天只谈作品，谢谢大家关心。”其工作室随后发布行程图，未对截图真伪作出说明。",
      "多位粉丝在超话内呼吁“不要过度解读”，也有网友指出截图的纸张纹理与现行登记表不一致，真实性存疑。",
    ],
  },
  {
    id: "s7",
    title: "老小区加装电梯卡在“一楼签字” 街道介入调解",
    summary:
      "同一栋楼十二户中仅两户反对，工程停滞八个月，街道提出“分层分摊+采光补偿”新方案。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-1",
    publishedAt: "2026-10-15T20:18:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Old%20six-story%20residential%20building%20with%20a%20newly%20installed%20glass%20elevator%20shaft%2C%20autumn%20trees%20and%20warm%20afternoon%20sunlight%2C%20everyday%20urban%20neighborhood%2C%20documentary%20architecture%20photography%2C%20clean%20composition%2C%20high%20detail&width=1024&height=640&seq=baoliao-s7&orientation=landscape",
    tags: ["加装电梯", "社区"],
    author: "爆料网社会组",
    views: 96340,
    heat: 78,
    content: [
      "这栋建成于1998年的六层住宅，共十二户居民。2025年底，十户业主同意加装电梯并完成初步设计，但一楼两户始终未签字，理由是“施工影响采光，且我们根本用不上”。",
      "八个月里，业主代表先后组织了四次协调会。五楼的住户王阿姨说，家里老人已经三个月没下过楼，“我们知道一楼有顾虑，但总得有个解决办法”。",
      "15日，街道办牵头提出新方案：一楼住户不出资，并由楼上业主按楼层系数分摊一笔采光补偿；电梯井道外移1.2米以减少遮挡。方案将在本周内投票表决。",
    ],
  },
  {
    id: "e7",
    title: "演员顾承宇罢演传闻 制片方称“档期协调中”",
    summary:
      "剧组停工两天，网传因剧本修改引发分歧，制片方回应称属于正常调整，不影响上线时间。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-2",
    publishedAt: "2026-10-15T18:06:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Quiet%20film%20production%20office%20with%20stacked%20script%20binders%2C%20a%20desk%20lamp%20casting%20warm%20light%2C%20empty%20director%20chair%20in%20the%20corner%2C%20moody%20editorial%20photography%2C%20muted%20amber%20and%20charcoal%20tones%2C%20high%20detail&width=1024&height=640&seq=baoliao-e7&orientation=landscape",
    tags: ["剧组", "停拍"],
    author: "爆料网娱乐组",
    views: 176430,
    heat: 82,
    content: [
      "15日上午，有网友在影视基地附近拍到剧组大门紧闭、设备车辆停放的画面，随后“罢演”一说开始流传。",
      "一位剧组工作人员向记者确认，14日与15日确实没有拍摄安排，“主要是剧本后十集在调整，演员需要时间重新对词”。对于“罢演”的说法，他表示“没听说”。",
      "制片方下午回应称，项目处于正常的档期协调阶段，已与主演团队达成一致，预计下周恢复拍摄，上线时间不受影响。",
    ],
  },
  {
    id: "s8",
    title: "高速服务区天价拖车费 涉事公司被约谈",
    summary:
      "车主称三公里拖车被收1800元，且未提供收费明细，当地交通部门已介入调查。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-3",
    publishedAt: "2026-10-15T14:52:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Highway%20service%20area%20at%20dusk%20with%20a%20tow%20truck%20parked%20beside%20a%20broken-down%20sedan%2C%20orange%20sky%20and%20asphalt%20reflections%2C%20roadside%20documentary%20photography%2C%20warm%20cinematic%20tones%2C%20high%20detail&width=1024&height=640&seq=baoliao-s8&orientation=landscape",
    tags: ["消费维权", "拖车"],
    author: "爆料网社会组",
    views: 118920,
    heat: 80,
    content: [
      "10月12日，车主李先生的车在高速服务区附近抛锚，拨打救援电话后，一辆拖车将车拖至三公里外的维修点，收费1800元，且只给了一张手写收据。",
      "“我问为什么这么贵，对方说夜间出车加急费另算。”李先生提供的录音中，工作人员未能说明具体计价标准。",
      "当地交通部门15日回应，已约谈涉事救援公司，要求提供完整收费依据，并将对该路段救援服务价格开展专项检查。",
    ],
  },
  {
    id: "e8",
    title: "音乐节压轴歌手临时换人 主办方开放全额退票",
    summary:
      "开场前四小时公布阵容调整，主办方称因艺人突发声带问题，已开放全额退票通道。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-4",
    publishedAt: "2026-10-15T12:30:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20main%20stage%20in%20late%20afternoon%2C%20empty%20stage%20with%20truss%20lights%20and%20large%20LED%20screen%2C%20crowd%20silhouettes%20in%20the%20distance%2C%20warm%20sunset%20haze%2C%20editorial%20concert%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-e8&orientation=landscape",
    tags: ["音乐节", "退票"],
    author: "爆料网娱乐组",
    views: 149870,
    heat: 81,
    content: [
      "15日11时，主办方在官方账号发布公告，宣布当晚压轴表演嘉宾因突发声带问题无法登台，由另一组乐队替补，演出时长不变。",
      "公告发布时距离入场仅四小时，不少观众已在路上。社交平台上，“退票”话题迅速升温，有观众表示“专门为压轴买的单日票”。",
      "主办方随后补充说明，已购票观众可在三日内申请全额退款，也可选择保留门票兑换下一场演出。截至发稿，退票通道页面访问量已超过二十万。",
    ],
  },
  {
    id: "s9",
    title: "便利店临期食品标签被改写 记者暗访三天",
    summary:
      "店员用溶剂擦除原日期后重新打印，涉及三明治、饭团等十多个品类，总部已启动核查。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-5",
    publishedAt: "2026-10-14T21:36:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Convenience%20store%20shelf%20with%20packaged%20sandwiches%20and%20rice%20balls%20under%20bright%20cool%20lighting%2C%20price%20tags%20and%20date%20labels%20in%20focus%2C%20clean%20retail%20photography%2C%20subtle%20warm%20accents%2C%20high%20detail&width=1024&height=640&seq=baoliao-s9&orientation=landscape",
    tags: ["便利店", "临期食品"],
    author: "爆料网调查组",
    views: 203470,
    heat: 85,
    content: [
      "10月11日至13日，记者连续三晚在同一家便利店观察。每晚临近打烊，店员会把未售出的三明治和饭团集中到操作间，用棉片蘸取溶剂擦拭包装上的日期喷码，再用小型打印机重新打上日期。",
      "一位离职员工向记者证实，这种做法“至少持续了半年”，“总部对损耗率有考核，超过标准店长要被扣钱”。",
      "便利店品牌总部14日晚回应，已成立专项小组赴门店核查，涉事门店即日起停业，同时对同城其余门店开展临期食品专项检查。",
    ],
  },
  {
    id: "e9",
    title: "影后江晚晴婚礼现场布置曝光 只邀三十位亲友",
    summary:
      "婚礼在海边民宿举行，没有媒体通道，现场以白色棉麻与干花为主，伴手礼是手写信和本地蜂蜜。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-6",
    publishedAt: "2026-10-14T18:20:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20seaside%20wedding%20ceremony%20setup%20with%20white%20linen%20drapes%2C%20dried%20flowers%20and%20wooden%20benches%2C%20soft%20overcast%20coastal%20light%2C%20muted%20sand%20and%20cream%20palette%2C%20editorial%20wedding%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-e9&orientation=landscape",
    tags: ["婚礼", "现场"],
    author: "爆料网娱乐组",
    views: 233190,
    heat: 87,
    content: [
      "14日下午，有网友在社交平台晒出一组海边民宿的照片，称是江晚晴婚礼的布置现场。照片中，仪式区只有两排木质长椅，背景是一面白色棉麻布幔。",
      "民宿工作人员向记者确认，场地在本周被整体包下，搭建时间为两天，“没有请婚庆公司，很多布置是新人自己带来的”。",
      "据知情者透露，婚礼只邀请三十位亲友，不设媒体通道，伴手礼是一封手写信和一罐本地蜂蜜。江晚晴方面未对此作出回应。",
    ],
  },
  {
    id: "s10",
    title: "暴雨夜地下车库进水 业主质疑物业未预警",
    summary:
      "积水最深处超过半米，二十余辆车受损，业主称物业在进水一小时后才发出通知。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-3",
    publishedAt: "2026-10-14T15:08:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Underground%20parking%20garage%20with%20shallow%20flood%20water%20reflecting%20ceiling%20lights%2C%20parked%20cars%20and%20concrete%20columns%2C%20cool%20blue-grey%20tones%20with%20warm%20lamp%20glow%2C%20documentary%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-s10&orientation=landscape",
    tags: ["物业", "暴雨"],
    author: "爆料网社会组",
    views: 172480,
    heat: 83,
    content: [
      "12日夜间，城区出现短时强降雨。某小区地下车库的两个出入口排水不畅，积水在四十分钟内漫过轮胎一半高度。",
      "业主提供的群聊记录显示，物业首次发布提醒的时间为23时17分，而监控画面显示车库在22时10分左右已开始进水。",
      "物业经理回应称，当晚值班人员先组织排水，未及时在群内通报，“确实是我们的疏漏”。目前物业已登记受损车辆，并表示将通过保险与协商方式处理赔偿。",
    ],
  },
  {
    id: "e10",
    title: "选秀节目投票被指刷票 平台公布后台日志",
    summary:
      "某选手单小时票数暴涨四十万，平台称系“异常账号集中投票”，已冻结相关票数。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-2",
    publishedAt: "2026-10-13T20:44:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Television%20studio%20voting%20dashboard%20with%20glowing%20bar%20charts%20on%20a%20large%20screen%2C%20dark%20stage%20with%20warm%20orange%20spotlights%2C%20abstract%20data%20visualization%20aesthetic%2C%20editorial%20tech%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-e10&orientation=landscape",
    tags: ["选秀", "投票"],
    author: "爆料网娱乐组",
    views: 194320,
    heat: 86,
    content: [
      "13日凌晨，有观众发现某选秀节目的实时投票榜出现异常：一名选手的票数在一小时内增加约四十万，而此前整日均值为八万。",
      "节目组当天下午公布部分后台日志，称监测到同一IP段集中注册的账户在两小时内完成投票，已按规则冻结相关票数，并封禁异常账号一万三千余个。",
      "多位粉丝表示接受解释，但也有人质疑“为什么每次都是同一家粉丝被质疑”。节目组称将在决赛前上线更严格的验证机制。",
    ],
  },
  {
    id: "s11",
    title: "网约车“拼单绕路”计费争议 平台公布行程轨迹",
    summary:
      "乘客称三公里路程被计费十一公里，平台回应称拼单成功按实际里程计价，已退还差价。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-3",
    publishedAt: "2026-10-13T11:26:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Smartphone%20mounted%20on%20a%20car%20dashboard%20showing%20a%20navigation%20route%20map%2C%20city%20street%20blurred%20through%20the%20windshield%20at%20dusk%2C%20warm%20amber%20dashboard%20lights%2C%20editorial%20mobility%20photography%2C%20high%20detail&width=1024&height=640&seq=baoliao-s11&orientation=landscape",
    tags: ["网约车", "计费"],
    author: "爆料网社会组",
    views: 87420,
    heat: 72,
    content: [
      "10月11日，乘客赵女士从地铁站打车回家，直线距离不到三公里。行程结束后，账单显示里程11.4公里，费用为原预估的三倍。",
      "赵女士查看轨迹发现，车辆先后绕行两个小区接送拼单乘客。平台客服最初回应称“拼单成功后按实际里程计价”。",
      "12日晚，平台再次回应，承认该订单中有一段路线为司机手动改道且未获乘客确认，已退还差价并补偿优惠券，同时对司机进行规范培训。",
    ],
  },
  {
    id: "e11",
    title: "悬疑片《雾中来客》口碑逆袭 排片从8%涨到21%",
    summary:
      "上映第三天单日票房反超同档期大制作，导演发文感谢观众，主演路演行程临时加场。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-4",
    publishedAt: "2026-10-12T22:10:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Foggy%20mountain%20road%20at%20dawn%20with%20a%20single%20streetlamp%20and%20distant%20silhouette%2C%20dense%20mist%2C%20muted%20cool%20greys%20with%20warm%20amber%20glow%2C%20cinematic%20suspense%20film%20still%20aesthetic%2C%20high%20detail&width=1024&height=640&seq=baoliao-e11&orientation=landscape",
    tags: ["电影", "逆袭"],
    author: "爆料网娱乐组",
    views: 156730,
    heat: 84,
    content: [
      "《雾中来客》首日排片仅8.4%，但凭借口碑发酵，上映第三天单日票房超过同档期一部投资更高的商业片，排片占比在48小时内从8.4%升至21%。",
      "导演在社交平台发文：“我们没有钱做大规模点映，只能一场一场跑。”据发行方透露，主演路演行程已临时增加六个城市。",
      "多位影院经理表示，该片的上座率在工作日下午仍能维持在35%以上，“这是加排片的直接原因”。",
    ],
  },
  {
    id: "s12",
    title: "保障房摇号名单出现重复身份证号 官方连夜核查",
    summary:
      "公示名单中两个不同姓名对应同一证件号，住建部门称系录入错误，将重新公示并接受复核。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-1",
    publishedAt: "2026-10-12T10:04:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Official%20notice%20board%20with%20printed%20name%20lists%20and%20documents%20pinned%20on%20a%20glass%20wall%2C%20people%20reading%20closely%2C%20soft%20indoor%20lighting%2C%20warm%20neutral%20tones%2C%20documentary%20photography%2C%20clean%20composition%2C%20high%20detail&width=1024&height=640&seq=baoliao-s12&orientation=landscape",
    tags: ["保障房", "公示"],
    author: "爆料网社会组",
    views: 142360,
    heat: 79,
    content: [
      "10月11日晚，有市民在查看保障房摇号公示名单时发现，两个不同姓名后面对应的身份证号完全一致，随即发布在社交平台。",
      "12日凌晨，住建部门发布说明，称经初步核查为工作人员录入时复制粘贴错误，实际对应两个不同申请人，相关材料已经复核。",
      "部门表示将在三日内重新公示完整名单，并开放线上复核通道，市民可凭申请编号查询自己的排序结果。",
    ],
  },
  {
    id: "e12",
    title: "双顶流同框代言 品牌方连夜加单",
    summary:
      "两位演员首次共同出镜拍摄广告，物料上线一小时转发破百万，品牌方称线下门店物料将提前投放。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-6",
    publishedAt: "2026-10-11T19:52:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20minimal%20studio%20set%20with%20two%20empty%20director%20chairs%2C%20large%20softboxes%20and%20a%20seamless%20cream%20backdrop%2C%20warm%20editorial%20fashion%20lighting%2C%20high-end%20advertising%20photography%2C%20elegant%20negative%20space%2C%20high%20detail&width=1024&height=640&seq=baoliao-e12&orientation=landscape",
    tags: ["代言", "同框"],
    author: "爆料网娱乐组",
    views: 264870,
    heat: 88,
    content: [
      "10日晚，某护肤品牌发布两位演员共同出镜的广告片，这是两人出道以来首次商业同框。物料上线一小时，官方账号转发量突破一百万。",
      "品牌方内部人士透露，原计划分两轮投放，因数据超出预期，已决定提前把线下门店物料铺到一线城市，“工厂那边连夜加单”。",
      "两位演员的工作室均转发了该条内容，未附加说明。粉丝在评论区讨论最多的，是广告片结尾一闪而过的双人镜头。",
    ],
  },
  {
    id: "s13",
    title: "菜市场电子秤抽查 三家摊位误差超标被查",
    summary:
      "执法人员随机抽查二十六台电子秤，发现三台存在“九两秤”问题，市场管理方承诺先行赔付。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-5",
    publishedAt: "2026-10-10T16:34:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Bustling%20indoor%20vegetable%20market%20stall%20with%20fresh%20produce%20crates%20and%20a%20digital%20scale%20on%20the%20counter%2C%20warm%20daylight%20through%20the%20roof%20windows%2C%20documentary%20market%20photography%2C%20rich%20colors%2C%20high%20detail&width=1024&height=640&seq=baoliao-s13&orientation=landscape",
    tags: ["计量", "菜市场"],
    author: "爆料网社会组",
    views: 76840,
    heat: 68,
    content: [
      "10日上午，市场监管部门对城西一家农贸市场的电子秤开展随机抽查，共检查二十六台，发现三台存在计量偏差。",
      "执法人员现场用标准砝码测试，其中一台显示1.1公斤，实际重量为1公斤。摊主称“秤用了好几年，没校过”。",
      "市场管理方表示，将统一更换合格电子秤并设置公平秤复称点，消费者如遇短斤缺两可凭小票先行赔付。",
    ],
  },
  {
    id: "s14",
    title: "社区食堂午市排队两小时 运营方称将增设窗口",
    summary:
      "六十岁以上老人可享八折，周边上班族也来“蹭饭”，单日供餐量超出设计容量近一倍。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-1",
    publishedAt: "2026-10-09T13:18:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Community%20canteen%20interior%20with%20long%20wooden%20tables%2C%20tray%20counter%20and%20warm%20pendant%20lights%2C%20elderly%20diners%20and%20office%20workers%20queueing%20politely%2C%20cozy%20documentary%20photography%2C%20warm%20neutral%20palette%2C%20high%20detail&width=1024&height=640&seq=baoliao-s14&orientation=landscape",
    tags: ["社区食堂", "民生"],
    author: "爆料网社会组",
    views: 61230,
    heat: 65,
    content: [
      "这家社区食堂9月底开业，主打两荤一素15元，六十岁以上老人再打八折。开业两周，午市队伍从店内排到了人行道。",
      "运营方统计，单日最高供餐量达到680份，而厨房设计容量为360份。“我们低估了周边写字楼的客流。”负责人说。",
      "目前食堂已增加一个取餐窗口，并把出餐时间提前半小时。街道表示，正在协调相邻场地扩建就餐区。",
    ],
  },
  {
    id: "s15",
    title: "公园健身器材伤人 管理方称将全面排查",
    summary:
      "一名儿童在使用漫步机时扶手断裂擦伤手臂，家属质疑器材超期服役，园方已封闭该区域。",
    category: "社会爆料",
    categorySlug: "society",
    topicId: "topic-3",
    publishedAt: "2026-10-08T17:46:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Outdoor%20public%20park%20fitness%20equipment%20area%20with%20worn%20painted%20metal%20machines%20and%20rubber%20flooring%2C%20autumn%20trees%20and%20soft%20late%20afternoon%20light%2C%20documentary%20photography%2C%20muted%20warm%20tones%2C%20high%20detail&width=1024&height=640&seq=baoliao-s15&orientation=landscape",
    tags: ["公共设施", "安全"],
    author: "爆料网社会组",
    views: 54320,
    heat: 61,
    content: [
      "10月7日下午，一名八岁儿童在公园使用漫步机时，右侧扶手焊接处突然断裂，孩子手臂被划出一道约五厘米的伤口。",
      "家属查看器材铭牌后发现，安装日期为2014年，标注的安全使用年限为八年。“早就该换了，为什么还在用？”",
      "公园管理方8日回应，已封闭该健身区域并联系厂家排查同类器材，同时表示将承担孩子的医疗费用。",
    ],
  },
  {
    id: "e13",
    title: "综艺录制现场冲突 节目组致歉并停录一期",
    summary:
      "两位嘉宾在游戏环节发生推搡，现场观众称录制中断四十分钟，节目组称已协调双方。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-2",
    publishedAt: "2026-10-17T07:36:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20television%20variety%20show%20set%20with%20colorful%20game%20props%2C%20cameras%20on%20tripods%20and%20warm%20studio%20lighting%2C%20behind-the-scenes%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=1024&height=640&seq=baoliao-e13&orientation=landscape",
    tags: ["综艺", "录制"],
    author: "爆料网娱乐组",
    views: 301250,
    heat: 91,
    content: [
      "16日晚，一档竞技类综艺在郊区影棚录制。多位现场观众称，两位嘉宾在“抢位”游戏环节发生推搡，其中一人摔倒在道具垫上。",
      "“现场一下就安静了，导演喊停，工作人员把两人分开。”一位观众回忆，录制中断约四十分钟后才恢复。",
      "节目组17日凌晨发布致歉声明，称已协调双方并暂停一期录制，相关片段不会播出。两位嘉宾工作室均未单独回应。",
    ],
  },
  {
    id: "e14",
    title: "老牌歌手巡演加场 门票三十秒售罄",
    summary:
      "主办方称加场是因为“系统统计有大量重复订单被释放”，二手平台溢价已超过三倍。",
    category: "娱乐爆料",
    categorySlug: "entertainment",
    topicId: "topic-4",
    publishedAt: "2026-10-16T20:14:00+08:00",
    image:
      "https://readdy.ai/api/search-image?query=Concert%20arena%20interior%20with%20rows%20of%20empty%20seats%20and%20a%20large%20stage%20lit%20by%20warm%20amber%20spotlights%2C%20dramatic%20haze%2C%20editorial%20music%20venue%20photography%2C%20high%20detail%2C%20clean%20wide%20composition&width=1024&height=640&seq=baoliao-e14&orientation=landscape",
    tags: ["演唱会", "门票"],
    author: "爆料网娱乐组",
    views: 187650,
    heat: 85,
    content: [
      "16日中午，老牌歌手巡演本地站加场门票开售，三十秒内显示售罄。主办方称本轮共释放约八千张票，其中一部分来自此前被判定为重复下单的订单。",
      "不少粉丝在社交平台晒出排队截图，显示“前方还有四万人”。与此同时，二手交易平台出现大量溢价票，最高报价达到原价的三倍。",
      "主办方提醒观众通过官方渠道购票，并表示将在演出前一周开放实名转赠通道，以降低退票损失。",
    ],
  },
];

export const topics: TopicItem[] = [
  {
    id: "topic-1",
    name: "城中村改造风波",
    subtitle: "补偿、签约与安置的每一步",
    description:
      "从补偿方案流出到加装电梯卡壳，聚焦城市更新中最贴近生活的那部分细节。我们持续收录居民、街道与施工方的多方说法，还原政策落地时的真实摩擦。",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20urban%20village%20alley%20with%20densely%20packed%20low-rise%20buildings%2C%20laundry%20hanging%20outside%20windows%2C%20new%20high-rise%20towers%20rising%20in%20the%20hazy%20background%2C%20warm%20late%20afternoon%20light%2C%20editorial%20urban%20photography%2C%20high%20detail&width=1200&height=560&seq=baoliao-topic-1&orientation=landscape",
    keywords: ["城市更新", "补偿方案", "社区"],
  },
  {
    id: "topic-2",
    name: "娱乐圈合约纠纷",
    subtitle: "声明、律师函与未说完的话",
    description:
      "合约、分成、解约与罢演，是这个行业最容易被放大的部分。专题汇总近期多起纠纷的公开信息与各方回应，不做判断，只把时间线摆清楚。",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20legal%20contracts%20and%20a%20fountain%20pen%20on%20a%20dark%20desk%2C%20dramatic%20single%20light%20source%2C%20deep%20shadows%2C%20warm%20amber%20highlights%2C%20editorial%20still%20life%20photography%2C%20high%20detail&width=1200&height=560&seq=baoliao-topic-2&orientation=landscape",
    keywords: ["解约", "经纪公司", "声明"],
  },
  {
    id: "topic-3",
    name: "城市安全追踪",
    subtitle: "那些发生在通勤路上的突发事件",
    description:
      "地铁停运、车库进水、服务区纠纷、健身器材伤人——城市生活的安全细节，往往在事发之后才被看见。专题按时间顺序收录相关爆料与后续处理进展。",
    cover:
      "https://readdy.ai/api/search-image?query=Rain-soaked%20city%20crossing%20at%20night%20with%20traffic%20lights%20reflecting%20on%20wet%20asphalt%2C%20commuters%20with%20umbrellas%2C%20moody%20cinematic%20urban%20photography%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20high%20detail&width=1200&height=560&seq=baoliao-topic-3&orientation=landscape",
    keywords: ["公共交通", "安全", "突发"],
  },
  {
    id: "topic-4",
    name: "暑期档票房大战",
    subtitle: "提档、逆袭与排片博弈",
    description:
      "票房数字每天都在变，排片表也是。专题追踪档期内影片的提档、加场与口碑变化，看看一部电影是如何在两周内被观众重新排序的。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20auditorium%20with%20rows%20of%20red%20seats%20and%20a%20glowing%20blank%20screen%2C%20projector%20beam%20cutting%20through%20haze%2C%20warm%20cinematic%20lighting%2C%20editorial%20photography%2C%20clean%20symmetrical%20composition%2C%20high%20detail&width=1200&height=560&seq=baoliao-topic-4&orientation=landscape",
    keywords: ["电影", "票房", "档期"],
  },
  {
    id: "topic-5",
    name: "舌尖上的暗访",
    subtitle: "后厨、标签与那杆秤",
    description:
      "食品安全问题很少以戏剧化的方式出现，它更多藏在一张重复填写的温度表、一枚被擦掉的日期里。专题汇总近期餐饮与零售环节的调查报道。",
    cover:
      "https://readdy.ai/api/search-image?query=Commercial%20kitchen%20pass%20with%20stainless%20steel%20prep%20tables%2C%20labeled%20containers%20and%20warm%20overhead%20lamps%2C%20clean%20clinical%20food%20safety%20scene%2C%20documentary%20photography%2C%20high%20detail&width=1200&height=560&seq=baoliao-topic-5&orientation=landscape",
    keywords: ["食品安全", "调查", "餐饮"],
  },
  {
    id: "topic-6",
    name: "明星婚礼风云",
    subtitle: "从彩排照到伴手礼",
    description:
      "婚礼是娱乐圈最受关注的私人事件。专题收集近期的婚礼现场细节、宾客规模与官方回应，也记录那些被过度解读的瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20evening%20garden%20wedding%20venue%20with%20warm%20fairy%20lights%2C%20white%20flower%20arches%20and%20long%20banquet%20tables%2C%20soft%20dusk%20sky%2C%20editorial%20event%20photography%2C%20elegant%20warm%20palette%2C%20high%20detail&width=1200&height=560&seq=baoliao-topic-6&orientation=landscape",
    keywords: ["婚礼", "明星动态", "现场"],
  },
];

export const hotSearches: string[] = [
  "城中村",
  "婚礼",
  "合约",
  "火锅",
  "票房",
  "电梯",
  "选秀",
  "声明",
];